/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

import { on, off } from 'utils/dom/dom';

import { Button } from 'components/core/Button';
import { SFIcon } from 'components/core/SFIcon';
import { FacilityCard } from 'components/search/FacilityCard';

export function enhance(WrappedComponent) {
	return function WithFacilityInfoContentLogic(props) {
		const [mouseIsDownOnCard, setMouseIsDownOnCard] = React.useState(false);

		const handleMouseDown = React.useCallback(
			() => setMouseIsDownOnCard(true),
			[],
		);
		const handleMouseUp = React.useCallback(
			() => setMouseIsDownOnCard(false),
			[],
		);

		const mouseIsDownRef = React.useRef(false);
		mouseIsDownRef.current = mouseIsDownOnCard;

		const onClickOutsideRef = React.useRef(props.onClickOutside);
		onClickOutsideRef.current = props.onClickOutside;

		const handleClick = React.useCallback((e) => {
			if (!mouseIsDownRef.current) {
				onClickOutsideRef.current(e);
			}
		}, []);

		const handleCloseClick = React.useCallback((e) => {
			onClickOutsideRef.current(e);
		}, []);

		React.useEffect(() => {
			on('mousedown', handleClick);
			return () => off('mousedown', handleClick);
		}, [handleClick]);

		const facilityUrl = props.facility
			? props.facility.url.facility
			: undefined;

		return (
			<WrappedComponent
				{...props}
				mouseIsDownOnCard={mouseIsDownOnCard}
				handleMouseDown={handleMouseDown}
				handleMouseUp={handleMouseUp}
				handleClick={handleClick}
				handleCloseClick={handleCloseClick}
				facilityUrl={facilityUrl}
			/>
		);
	};
}

export function FacilityInfoContent({
	facility,
	getLocalPhoneNumberByZipCode,
	handleMouseDown,
	handleMouseUp,
	handleCloseClick,
	phone
}) {
	return (
		<div
			className="overlay-content"
			onMouseDown={handleMouseDown}
			onMouseUp={handleMouseUp}
		>
			<Button
				primary={false}
				className="dismiss-icon"
				onClick={handleCloseClick}
			>
				<SFIcon icon="close" />
			</Button>
			<div className="overlay-content-body">
				<div className="fac-info-card">
					<FacilityCard
						facility={facility}
						phone={phone}
						getLocalPhoneNumberByZipCode={getLocalPhoneNumberByZipCode}
						lazyLoad={false}
					/>
				</div>
			</div>
			<div className="overlay-pointer" />
		</div>
	);
}

FacilityInfoContent.propTypes = {
	facility: PropTypes.object,
	getLocalPhoneNumberByZipCode: PropTypes.func,
	handleMouseDown: PropTypes.func,
	handleMouseUp: PropTypes.func,
	handleCloseClick: PropTypes.func,
	phone: PropTypes.object
};

export default enhance(FacilityInfoContent);
